namespace GeniuzPOS.Purchase {
    export interface PoApprovalTranRow {
        Id?: number;
        DocType?: string;
        SysDocNo?: string;
        DocAmt?: number;
        Level?: number;
        ApprGroupCode?: string;
        ApprGroupName?: string;
        ApproveFg?: ApproveFgonApptran;
        ApproveBy?: string;
        ApproveDate?: string;
        AppActiveFg?: ApproveFgonApptran;
    }

    export namespace PoApprovalTranRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Purchase.PoApprovalTran';
        export const lookupKey = 'Purchase.PoApprovalTran';

        export function getLookup(): Q.Lookup<PoApprovalTranRow> {
            return Q.getLookup<PoApprovalTranRow>('Purchase.PoApprovalTran');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            DocType = "DocType",
            SysDocNo = "SysDocNo",
            DocAmt = "DocAmt",
            Level = "Level",
            ApprGroupCode = "ApprGroupCode",
            ApprGroupName = "ApprGroupName",
            ApproveFg = "ApproveFg",
            ApproveBy = "ApproveBy",
            ApproveDate = "ApproveDate",
            AppActiveFg = "AppActiveFg"
        }
    }
}
